import { useAuth } from "@/providers/auth.provider";
import { useNavigate } from "@tanstack/react-router";
import { useRegisterUser } from "../queries/auth.create.queries";
import { useState } from "react";
import { AuthState, RegisterInput } from "@/types/auth.types";
import { useForm } from "react-hook-form";
import { registerSchema } from "../schemas/auth.schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import { AUTH_ERRORS } from "@/constants/auth.errors";
import { driverJs } from "@/lib/driver";
import { sleep } from "@/lib/utils";

export const useRegister = () => {
  const navigate = useNavigate();

  const { setAuthState, refetch } = useAuth();

  const { mutateAsync: registerUser, isPending } = useRegisterUser();

  const [error, setError] = useState<string | null>(null);

  const form = useForm<RegisterInput>({
    resolver: zodResolver(registerSchema),
    defaultValues: {
      email: "",
      password: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",
      instituteName: "",
    },
  });

  const onSubmit = async (data: RegisterInput) => {
    setAuthState(AuthState.AUTHENTICATING);

    setError(null);

    try {
      const response = await registerUser(data);

      console.log("RESPONSE FROM TRY CATCH", response);

      if (response.success) {
        toast.success("Successfully registered!");

        await refetch();

        await navigate({
          to: "/dashboard",
          replace: true,
        });
        await sleep(200);
        driverJs.drive();
        return;
      }

      setAuthState(AuthState.UNAUTHENTICATED);
      setError(response.error || AUTH_ERRORS.INVALID_CREDENTIALS);
    } catch (error) {
      setAuthState(AuthState.UNAUTHENTICATED);
      setError(AUTH_ERRORS.INVALID_CREDENTIALS);
    }
  };

  return { form, onSubmit, isPending, error };
};
